export default __webpack_public_path__ + "static/media/light-dash.cdc2b7a2.png";